export default __webpack_public_path__ + "static/media/sop_selected.e39eaa9d.svg";